import DynamicFieldList from '@/components/form/shared/DynamicFieldList';

import { renderBasicFieldControl } from './renderBasicFieldControl';

import type { FieldConfig, FieldRenderContext } from './types';
import type { ReactNode } from 'react';

export function renderFieldControl(
  field: FieldConfig,
  ctx: FieldRenderContext,
): ReactNode {
  if (field.type === 'custom' && field.render) {
    return field.render(ctx);
  }

  if (field.type === 'list') {
    if (!field.name || !field.listRenderRow) {
      return null;
    }
    return (
      <DynamicFieldList
        name={field.name}
        min={field.listMin ?? 1}
        defaultItem={field.listDefaultItem ?? {}}
        addLabel={field.listAddLabel}
        gutter={field.listGutter}
        rowWrapper={field.listRowWrapper}
        showAddButton={field.listShowAddButton}
        inputSize={ctx.inputSize}
        form={ctx.form}
        onRemove={(index) => field.listOnRemove?.(index)}
        renderRow={(rowCtx) =>
          field.listRenderRow!(rowCtx.field, rowCtx.index, rowCtx.remove, ctx)
        }
      />
    );
  }

  return renderBasicFieldControl(field, ctx);
}
